import type { ReactNode } from "react";
import { ChevronLeft } from "lucide-react";
import { TopLevelPageHeader } from "@/components/shared/TopLevelPageHeader";
import { PAGE_INFO } from "@/features/navigation/pages";
import { STASHES } from "@/routes";
import { CONTROL } from "@/lib/typography";
import { cn } from "@/lib/utils";

interface StashesPageHeaderProps {
  contentWidthClass: string;
  controls?: ReactNode;
  showControls: boolean;
  sourceStashId?: string;
  onReturnToSourceStash?: () => void;
  title?: string;
  loading?: boolean;
  search?: ReactNode;
}

export function StashesPageHeader({
  contentWidthClass,
  controls,
  showControls,
  sourceStashId,
  onReturnToSourceStash,
  title = PAGE_INFO["all-stashes"]!.title,
  loading = false,
  search,
}: StashesPageHeaderProps) {
  return (
    <TopLevelPageHeader
      title={title}
      loading={loading}
      href={showControls ? undefined : STASHES()}
      action={controls}
      showSafeAreaSpacer={false}
      wrapperClassName={contentWidthClass}
      search={search}
    >
      {sourceStashId ? (
        <div className="flex items-center justify-between gap-3">
          <div className="flex min-w-0 flex-1 items-center gap-3">
            <button
              type="button"
              onClick={onReturnToSourceStash}
              className={cn(CONTROL, "inline-flex items-center gap-1.5 text-foreground transition-opacity hover:opacity-80")}
            >
              <ChevronLeft className="h-4 w-4" />
              Back to Stash
            </button>
          </div>
          {controls && <div className="flex-shrink-0">{controls}</div>}
        </div>
      ) : undefined}
    </TopLevelPageHeader>
  );
}
